import _ from 'lodash'
import {
  buildUrl
} from '@/util.js'

export default {
  namespaced: true,
  actions: {
    async r ({dispatch, rootState, rootGetters}, options) {
      let key = 'nutsbp'
      let url = options.url
      options.url = buildUrl(rootGetters.rootDomain, key, url, options.query)
      delete options.query

      let res = await dispatch('api/r', options, {root: true})
      if (res.status < 400) {
        return _.get(res, 'data.data')
      }

      let code = _.get(res, 'data.code')
      let msg = _.get(res, 'data.msg', `请求失败。`)
      let moreInfo = [key, url, res.status, code]
      if (rootState.env !== 'prod') {
        msg = `${msg}(${moreInfo.join(', ')})`
      }
      throw new Error(msg)
    },
    /**************************************************
     * auth
     **************************************************/
    async me ({dispatch}) {
      let data = await dispatch('r', {
        url: '/me'
      })
      return data
    },
    /**************************************************
     * share data
     **************************************************/
    async industry ({dispatch}) {
      let data = await dispatch('r', {
        url: '/industry'
      })
      return data
    },
    /**************************************************
     * user data
     **************************************************/
    async cardinfo ({rootGetters, dispatch}, {uuid = null} = {}) {
      if (!uuid) {
        uuid = rootGetters['me/uuid']
      }
      let data = await dispatch('r', {
        url: `/user/${uuid}/cardinfo`
      })
      return data
    },
    async slide ({dispatch}) {
      let data = await dispatch('r', {
        url: '/slide'
      })
      let list = _.filter(data, { 'orientation': 2 })
      return _.orderBy(list, ['update_time'], ['desc'])
    },
    async getShareToken ({dispatch}, slideItem) {
      let url = '/slide/' + slideItem.unis + '/token'
      let result = await dispatch('r', {
        url,
        method: 'post'
      })
      return result
    },
    /**************************************************
     * modify data
     **************************************************/
    async updateMe ({rootGetters, dispatch}, data) {
      let uuid = rootGetters['me/uuid']
      let url = `/user/${uuid}`
      let rData = await dispatch('r', {
        url,
        method: 'patch',
        data
      })
      return rData
    },
    async deleteBp ({dispatch}, slideId) {
      let result = await dispatch('r', {
        url: '/slide/' + slideId,
        method: 'delete'
      })
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/api/nutsbp/index.js